const GROUP_TYPE_ACTIONS = {
    CLONE: {
        text: 'clone',
        icon: 'mdi-content-copy'
    },
    EDIT: {
        text: 'edit',
        icon: 'mdi-lead-pencil'
    },
    DELETE: {
        text: 'delete',
        icon: 'mdi-delete'
    }
}

export {
    GROUP_TYPE_ACTIONS,
}